import _regeneratorRuntime from "/builds/7ChVgkMg/1/gcp-backend/tea-h5/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/builds/7ChVgkMg/1/gcp-backend/tea-h5/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import { openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { ref, watchEffect, onMounted } from "vue";
import Common from "./Common.vue";
import { isFunction } from "@/utils/isUtil";
export default {
  __name: 'Confirm',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ""
    },
    desc: {
      type: String,
      default: ""
    },
    onOk: {
      type: Function,
      default: null
    },
    onCancel: {
      type: Function,
      default: null
    },
    okText: {
      type: String,
      default: ""
    },
    cancelText: {
      type: String,
      default: ""
    },
    withoutCancel: {
      type: Boolean,
      default: false
    },
    showBottomButton: {
      type: Boolean,
      default: true
    },
    hideBottomShadow: {
      type: Boolean,
      default: true
    },
    disableOkButton: {
      type: Boolean,
      default: false
    },
    cancelOnClickOverlay: {
      type: Boolean,
      default: false
    },
    showAfterMounted: {
      type: Boolean,
      default: false
    }
  },
  setup: function setup(__props) {
    var props = __props;
    var show = ref(false);
    var noloading = ref(false);
    var yesloading = ref(false);
    watchEffect(function () {
      if (props.visible) {
        show.value = true;
      }
    });
    function ok() {
      return _ok.apply(this, arguments);
    }
    function _ok() {
      _ok = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var res;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              if (!noloading.value) {
                _context.next = 3;
                break;
              }
              return _context.abrupt("return");
            case 3:
              if (!isFunction(props.onOk)) {
                _context.next = 8;
                break;
              }
              yesloading.value = true;
              _context.next = 7;
              return props.onOk();
            case 7:
              res = _context.sent;
            case 8:
              if (res === false) {
                show.value = true;
              } else {
                show.value = false;
              }
            case 9:
              _context.prev = 9;
              yesloading.value = false;
              return _context.finish(9);
            case 12:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[0,, 9, 12]]);
      }));
      return _ok.apply(this, arguments);
    }
    function cancel() {
      return _cancel.apply(this, arguments);
    }
    function _cancel() {
      _cancel = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              if (!yesloading.value) {
                _context2.next = 3;
                break;
              }
              return _context2.abrupt("return");
            case 3:
              if (!isFunction(props.onCancel)) {
                _context2.next = 7;
                break;
              }
              noloading.value = true;
              _context2.next = 7;
              return props.onCancel();
            case 7:
              show.value = false;
            case 8:
              _context2.prev = 8;
              noloading.value = false;
              return _context2.finish(8);
            case 11:
            case "end":
              return _context2.stop();
          }
        }, _callee2, null, [[0,, 8, 11]]);
      }));
      return _cancel.apply(this, arguments);
    }
    onMounted(function () {
      if (props.showAfterMounted) {
        show.value = true;
      }
    });
    return function (_ctx, _cache) {
      return _openBlock(), _createBlock(Common, {
        visible: show.value,
        "onUpdate:visible": _cache[0] || (_cache[0] = function ($event) {
          return show.value = $event;
        }),
        title: __props.title,
        desc: __props.desc,
        "on-ok": ok,
        "on-cancel": cancel,
        "ok-text": __props.okText,
        "cancel-text": __props.cancelText,
        "without-cancel": __props.withoutCancel,
        "show-bottom-button": __props.showBottomButton,
        "hide-bottom-shadow": __props.hideBottomShadow,
        "disable-ok-button": __props.disableOkButton,
        "cancel-on-click-overlay": __props.cancelOnClickOverlay
      }, null, 8, ["visible", "title", "desc", "ok-text", "cancel-text", "without-cancel", "show-bottom-button", "hide-bottom-shadow", "disable-ok-button", "cancel-on-click-overlay"]);
    };
  }
};